import SEOArticleLayout from "@/components/feature/SEOArticleLayout";
import { comparisonKakobuy } from "@/mocks/articles";

export default function HipobuyVsKakobuy() {
  return (
    <SEOArticleLayout
      slug={comparisonKakobuy.slug}
      title={comparisonKakobuy.title}
      metaDescription={comparisonKakobuy.metaDescription}
      publishDate={comparisonKakobuy.publishDate}
      readTime={comparisonKakobuy.readTime}
      badge={comparisonKakobuy.badge}
      heroImage={comparisonKakobuy.heroImage}
      sections={comparisonKakobuy.sections}
      relatedArticles={[
        { label: "Complete Guide", to: "/hipobuy-spreadsheet-complete-guide" },
        { label: "vs CSSBuy", to: "/hipobuy-spreadsheet-vs-cssbuy" },
        { label: "vs Superbuy", to: "/hipobuy-spreadsheet-vs-superbuy" },
        { label: "vs Oopbuy", to: "/hipobuy-spreadsheet-vs-oopbuy" },
        { label: "Category Deep-Dive", to: "/hipobuy-spreadsheet-category-deep-dive" },
      ]}
    />
  );
}